import { createSelector } from 'reselect'

import { getModals } from './reducer'

export const isOpen = (state, name) => getModals(state, name).open
export const getMessage = (state, name) => getModals(state, name).message
export const getParams = (state, name) => getModals(state, name).params || {}
export const getOnclose = (state, name) => getModals(state, name).onclose
export const getTotalOpenedModals = createSelector(getModals, (modals) => Object.keys(modals).length)
